export class MessageInterval {
    static defaultErrorMsgInterval = 6000;
    static errorMsgInterval = 6000;
    static warningMsgInterval = 3000;
    static infoMsgInterval = 5000;
    static successMsgInterval = 5000;
}
